module.exports = __webpack_public_path__ + "static/media/img-keelo-product-2.5045a450.png";